<template></template>
<script>
    /* Logout app */
    export default {
        created() {
            this.$auth.destroyToken();
            this.$store.dispatch('clearUser');
            this.$router.push({ path: '/' + this.$route.params.country.toLowerCase() });
        }
    }
</script>
<style></style>


// WEBPACK FOOTER //
// Logout.vue?1a1ddfc9